// src/components/Header.jsx
import React, { useState } from 'react';
import { ShoppingCart, X, Search } from 'lucide-react';

import logo from '../Images/new2.jpg';
import { theme } from '../utils/constants';

export default function Header({
  navigateTo,
  cartItemsCount,
  openCart,
  products
}) {

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [search, setSearch] = useState('');


  const navItems = [
    { label: 'Shop', page: 'shop' },
    { label: 'Track Order', page: 'tracking' },
    { label: 'Returns', page: 'returns' },
    { label: 'Login', page: 'login' }
  ];


  const toggleMobileMenu = () => {
    setMobileMenuOpen(prev => !prev);
  };


  const handleNavClick = (page) => {
    navigateTo(page);
    setMobileMenuOpen(false);
  };

  const handleSearch = (e) => {

  if(e.key === 'Enter' && search.trim()) {

    navigateTo('shop', {
      search: search.trim()
    });

    setMobileMenuOpen(false);

  }

};
  // const handleSearch = (e) => {

  //   if(e.key === 'Enter' && search.trim()) {

  //     navigateTo('shop', {
  //       search: search.trim()
  //     });

  //     setMobileMenuOpen(false);

  //   }

  // };


  return (

<header
style={{
background:'#fff',
color:'#111',
position:'sticky',
top:0,
zIndex:100,
borderBottom:'1px solid #e5e5e5',
boxShadow:'0 2px 12px rgba(0,0,0,0.06)'
}}
>


<div
style={{
maxWidth:'1280px',
margin:'0 auto',
padding:'0 24px'
}}
>


<div
style={{
display:'flex',
justifyContent:'space-between',
alignItems:'center',
height:'80px'
}}
>


{/* Logo */}

<div

onClick={() => navigateTo('/')}

style={{
display:'flex',
alignItems:'center',
cursor:'pointer',
gap:12
}}

>

<img
src={logo}
alt="Upendo Store"
style={{
height:52,
borderRadius:8
}}
/>


<span
style={{
fontSize:'1.6rem',
fontWeight:700,
fontFamily:"'Roboto Slab', serif",
color:'#111'
}}
>
UPENDO STORE
</span>


</div>





{/* Desktop Navigation */}

<nav

className="desktop-nav"

style={{

display:'flex',

alignItems:'center',

gap:'2rem'

}}

>



{/* Search */}

<div

style={{

position:'relative',

display:'flex',

alignItems:'center'

}}

>


<Search

size={20}

style={{

position:'absolute',

left:14,

color:theme.textLight

}}

/>


<input

value={search}

onChange={(e)=>setSearch(e.target.value)}

onKeyDown={handleSearch}

placeholder="Search products..."

style={{

width:'230px',

padding:'10px 15px 10px 42px',

borderRadius:'50px',

border:`1px solid ${theme.border}`,

outline:'none',

fontSize:'0.95rem',

transition:'all .25s'

}}

/>


</div>





{/* Links */}

{
navItems.map((item)=>(

<div

key={item.page}

onClick={()=>handleNavClick(item.page)}

onMouseEnter={(e)=>{

e.currentTarget.style.color=theme.primary;

}}

onMouseLeave={(e)=>{

e.currentTarget.style.color='#111';

}}

style={{

fontWeight:500,

color:'#111',

cursor:'pointer',

padding:'8px 0',

transition:'color .2s ease',

fontSize:'1.05rem'

}}

>

{item.label}

</div>

))

}






{/* Cart */}

<button

onClick={openCart}

style={{

background:'none',

border:'none',

color:'#111',

position:'relative',

cursor:'pointer'

}}

>

<ShoppingCart size={26}/>


{
cartItemsCount > 0 && (

<span

style={{

position:'absolute',

top:-10,

right:-10,

background:theme.accent,

color:'#111',

width:24,

height:24,

borderRadius:'50%',

fontSize:'0.8rem',

fontWeight:700,

display:'grid',

placeItems:'center'

}}

>

{cartItemsCount}

</span>

)

}


</button>


</nav>





{/* Mobile Hamburger */}

<button

className="mobile-hamburger"

onClick={toggleMobileMenu}

style={{

background:'none',

border:'none',

color:'#111',

fontSize:'2rem',

cursor:'pointer',

display:'none'

}}

>

{
mobileMenuOpen
?
<X size={30}/>
:
'☰'
}


</button>



</div>






{/* Mobile Menu */}

{
mobileMenuOpen && (

<div

className="mobile-menu"

style={{

background:'#fff',

borderTop:'1px solid #e5e5e5',

padding:'1.5rem 24px',

boxShadow:'0 8px 24px rgba(0,0,0,0.08)'

}}

>




{/* Mobile Search */}

<div

style={{

position:'relative',

marginBottom:'1.5rem'

}}

>


<Search

size={20}

style={{

position:'absolute',

left:15,

top:'50%',

transform:'translateY(-50%)',

color:theme.textLight

}}

/>


<input

value={search}

onChange={(e)=>setSearch(e.target.value)}

onKeyDown={handleSearch}

placeholder="Search products..."

style={{

width:'100%',

padding:'12px 15px 12px 42px',

borderRadius:'50px',

border:`1px solid ${theme.border}`,

outline:'none',

fontSize:'1rem'

}}

/>


</div>






{
navItems.map((item)=>(

<div

key={item.page}

onClick={()=>handleNavClick(item.page)}

style={{

padding:'12px 0',

fontSize:'1.1rem',

fontWeight:500,

cursor:'pointer'

}}

>

{item.label}

</div>


))

}






{/* Mobile Cart */}

<div

onClick={()=>{

openCart();

setMobileMenuOpen(false);

}}

style={{

padding:'12px 0',

fontSize:'1.1rem',

fontWeight:500,

cursor:'pointer',

display:'flex',

alignItems:'center',

gap:'12px'

}}

>


<ShoppingCart size={20}/>

Cart

{
cartItemsCount > 0 &&
` (${cartItemsCount})`
}


</div>



</div>

)

}


</div>





<style jsx global>{`

@media(max-width:768px){

.desktop-nav{

display:none !important;

}


.mobile-hamburger{

display:block !important;

}


}


@media(min-width:769px){

.mobile-menu{

display:none !important;

}

}

`}</style>



</header>


);

}

// // src/components/Header.jsx
// import React, { useState } from 'react';
// import { ShoppingCart, X } from 'lucide-react';

// import logo from '../Images/new2.jpg';
// import { theme } from '../utils/constants';

// export default function Header({
//   navigateTo,
//   cartItemsCount,
//   openCart
// }) {
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//   // const navItems = [
//   //   { label: 'Books', page: 'books' },
//   //   { label: 'Accessories', page: 'accessories' },
//   //   { label: 'Shop', page: 'shop' },
//   //   { label: 'Returns', page: 'returns' },
//   //   { label: 'Login', page: 'login' }
//   // ];
//   const navItems = [
//   { label: 'Shop', page: 'shop' },
//     // { label: 'Accessories', page: 'accessories' },
    
//     { label: 'Returns', page: 'returns' },
//     { label: 'Login', page: 'login' }
//   ];

//   const toggleMobileMenu = () => setMobileMenuOpen(prev => !prev);

//   const handleNavClick = (page) => {
//     navigateTo(page);
//     setMobileMenuOpen(false);
//   };

//   return (
//     <header
//       style={{
//         background: '#fff',
//         color: '#111',
//         position: 'sticky',
//         top: 0,
//         zIndex: 100,
//         borderBottom: '1px solid #e5e5e5',
//         boxShadow: '0 2px 12px rgba(0,0,0,0.06)'
//       }}
//     >
//       <div
//         style={{
//           maxWidth: '1280px',
//           margin: '0 auto',
//           padding: '0 24px'
//         }}
//       >
//         <div
//           style={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             height: '80px'
//           }}
//         >
//           {/* Logo */}
//           <div
//             onClick={() => navigateTo('/')}
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               cursor: 'pointer',
//               gap: 12
//             }}
//           >
//             <img
//               src={logo}
//               alt="Upendo Store"
//               style={{
//                 height: 52,
//                 borderRadius: 8
//               }}
//             />

//             <span
//               style={{
//                 fontSize: '1.6rem',
//                 fontWeight: 700,
//                 fontFamily: "'Roboto Slab', serif",
//                 color: '#111'
//               }}
//             >
//               UPENDO STORE
//             </span>
//           </div>

//           {/* Desktop Navigation */}
//           <nav
//             className="desktop-nav"
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '2.2rem'
//             }}
//           >
//             {navItems.map((item) => (
//               <div
//                 key={item.page}
//                 onClick={() => handleNavClick(item.page)}
//                 onMouseEnter={(e) => {
//                   e.target.style.color = theme.primary;
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.color = '#111';
//                 }}
//                 style={{
//                   fontWeight: 500,
//                   color: '#111',
//                   cursor: 'pointer',
//                   padding: '8px 0',
//                   transition: 'color 0.2s ease',
//                   fontSize: '1.05rem'
//                 }}
//               >
//                 {item.label}
//               </div>
//             ))}

//             <button
//               onClick={openCart}
//               style={{
//                 background: 'none',
//                 border: 'none',
//                 color: '#111',
//                 position: 'relative',
//                 cursor: 'pointer'
//               }}
//             >
//               <ShoppingCart size={26} />

//               {cartItemsCount > 0 && (
//                 <span
//                   style={{
//                     position: 'absolute',
//                     top: -10,
//                     right: -10,
//                     background: theme.accent,
//                     color: '#111',
//                     width: 24,
//                     height: 24,
//                     borderRadius: '50%',
//                     fontSize: '0.8rem',
//                     fontWeight: 700,
//                     display: 'grid',
//                     placeItems: 'center'
//                   }}
//                 >
//                   {cartItemsCount}
//                 </span>
//               )}
//             </button>
//           </nav>

//           {/* Mobile Hamburger */}
//           <button
//             className="mobile-hamburger"
//             onClick={toggleMobileMenu}
//             style={{
//               background: 'none',
//               border: 'none',
//               color: '#111',
//               fontSize: '2rem',
//               cursor: 'pointer',
//               display: 'none'
//             }}
//           >
//             {mobileMenuOpen ? <X size={30} /> : '☰'}
//           </button>
//         </div>

//         {/* Mobile Menu */}
//         {mobileMenuOpen && (
//           <div
//             className="mobile-menu"
//             style={{
//               background: '#fff',
//               borderTop: '1px solid #e5e5e5',
//               padding: '1.5rem 24px',
//               boxShadow: '0 8px 24px rgba(0,0,0,0.08)'
//             }}
//           >
//             {navItems.map((item) => (
//               <div
//                 key={item.page}
//                 onClick={() => handleNavClick(item.page)}
//                 onMouseEnter={(e) => {
//                   e.target.style.color = theme.primary;
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.color = '#111';
//                 }}
//                 style={{
//                   padding: '12px 0',
//                   fontSize: '1.1rem',
//                   fontWeight: 500,
//                   color: '#111',
//                   cursor: 'pointer',
//                   transition: 'color 0.2s ease'
//                 }}
//               >
//                 {item.label}
//               </div>
//             ))}

//             {/* Mobile Cart */}
//             <div
//               onClick={() => {
//                 openCart();
//                 setMobileMenuOpen(false);
//               }}
//               onMouseEnter={(e) => {
//                 e.target.style.color = theme.primary;
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.color = '#111';
//               }}
//               style={{
//                 padding: '12px 0',
//                 fontSize: '1.1rem',
//                 fontWeight: 500,
//                 color: '#111',
//                 cursor: 'pointer',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '12px',
//                 transition: 'color 0.2s ease'
//               }}
//             >
//               <ShoppingCart size={20} />
//               Cart {cartItemsCount > 0 && `(${cartItemsCount})`}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Responsive Styles */}
//       <style jsx global>{`
//         @media (max-width: 768px) {
//           .desktop-nav {
//             display: none !important;
//           }

//           .mobile-hamburger {
//             display: block !important;
//           }
//         }

//         @media (min-width: 769px) {
//           .mobile-menu {
//             display: none !important;
//           }
//         }
//       `}</style>
//     </header>
//   );
// }
// // src/components/Header.jsx
// import React, { useState } from 'react';
// import { ShoppingCart, X } from 'lucide-react';

// // import logo from '../Images/logo.JPEG';
// import logo from '../Images/new2.jpg';
// import { theme } from '../utils/constants';

// export default function Header({
//   navigateTo,
//   cartItemsCount,
//   openCart
// }) {
//   // Local state for mobile menu — no need to pass from App
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

//   const navItems = [
//     { label: 'Books', page: 'books' },
//     { label: 'Accessories', page: 'accessories' },
//     { label: 'Shop', page: 'shop' },
//     { label: 'Returns', page: 'returns' },
//     { label: 'Login', page: 'login' }  // ← replaced Home with Login
//   ];

//   const toggleMobileMenu = () => setMobileMenuOpen(prev => !prev);

//   // Close menu after clicking a link
//   const handleNavClick = (page) => {
//     navigateTo(page);
//     setMobileMenuOpen(false);
//   };

//   return (
//     <header
//       style={{
//         background: 'linear-gradient(135deg, #4527a0 0%, #5e35b1 100%)',
//         color: 'white',
//         position: 'sticky',
//         top: 0,
//         zIndex: 100,
//         boxShadow: theme.shadowMd
//       }}
//     >
//       <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
//         <div
//           style={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             height: '80px'
//           }}
//         >
//           {/* Logo */}
//           <div
//             onClick={() => navigateTo('/')} // changed to shop or login if preferred
//             style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', gap: 12 }}
//           >
//             <img src={logo} alt="Upendo Store" style={{ height: 52, borderRadius: 8 }} />
//             <span style={{ fontSize: '1.6rem', fontWeight: 700, fontFamily: "'Roboto Slab', serif" }}>
//               UPENDO STORE
//             </span>
//           </div>

//           {/* Desktop Nav */}
//           <nav style={{ display: 'flex', alignItems: 'center', gap: '2.2rem' }} className="desktop-nav">
//             {navItems.map(item => (
//               <div
//                 key={item.page}
//                 onClick={() => handleNavClick(item.page)}
//                 style={{
//                   fontWeight: 500,
//                   color: 'white',
//                   cursor: 'pointer',
//                   padding: '8px 0',
//                   transition: 'all 0.2s',
//                   fontSize: '1.05rem'
//                 }}
//               >
//                 {item.label}
//               </div>
//             ))}

//             <button
//               onClick={openCart}
//               style={{ background: 'none', border: 'none', color: 'white', position: 'relative', cursor: 'pointer' }}
//             >
//               <ShoppingCart size={26} />
//               {cartItemsCount > 0 && (
//                 <span
//                   style={{
//                     position: 'absolute', top: -10, right: -10,
//                     background: theme.accent, color: '#111',
//                     width: 24, height: 24, borderRadius: '50%',
//                     fontSize: '0.8rem', fontWeight: 700,
//                     display: 'grid', placeItems: 'center'
//                   }}
//                 >
//                   {cartItemsCount}
//                 </span>
//               )}
//             </button>
//           </nav>

//           {/* Mobile Hamburger */}
//           <button
//             className="mobile-hamburger"
//             onClick={toggleMobileMenu}
//             style={{
//               background: 'none',
//               border: 'none',
//               color: 'white',
//               fontSize: '2.1rem',
//               cursor: 'pointer',
//               display: 'none'
//             }}
//           >
//             {mobileMenuOpen ? <X size={32} /> : '☰'}
//           </button>
//         </div>

//         {/* Mobile Menu */}
//         {mobileMenuOpen && (
//           <div
//             style={{
//               background: 'linear-gradient(135deg, #4527a0 0%, #5e35b1 100%)',
//               padding: '1.5rem 24px',
//               boxShadow: '0 12px 32px rgba(0,0,0,0.35)'
//             }}
//             className="mobile-menu"
//           >
//             {navItems.map(item => (
//               <div
//                 key={item.page}
//                 onClick={() => handleNavClick(item.page)}
//                 style={{
//                   padding: '12px 0',
//                   fontSize: '1.15rem',
//                   fontWeight: 500,
//                   color: 'white',
//                   cursor: 'pointer'
//                 }}
//               >
//                 {item.label}
//               </div>
//             ))}

//             {/* Cart in mobile menu too */}
//             <div
//               onClick={() => {
//                 openCart();
//                 setMobileMenuOpen(false);
//               }}
//               style={{
//                 padding: '12px 0',
//                 fontSize: '1.15rem',
//                 fontWeight: 500,
//                 color: 'white',
//                 cursor: 'pointer',
//                 display: 'flex',
//                 alignItems: 'center',
//                 gap: '12px'
//               }}
//             >
//               <ShoppingCart size={20} />
//               Cart {cartItemsCount > 0 && `(${cartItemsCount})`}
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Responsive styles */}
//       <style jsx global>{`
//         @media (max-width: 768px) {
//           .desktop-nav { display: none !important; }
//           .mobile-hamburger { display: block !important; }
//         }
//         @media (min-width: 769px) {
//           .mobile-menu { display: none !important; }
//         }
//       `}</style>
//     </header>
//   );
// }
// // src/components/Header.jsx
// import React from 'react';
// import { ShoppingCart, X } from 'lucide-react';

// // Image – adjust path if needed
// import logo from '../Images/logo.JPEG';

// import { theme } from '../utils/constants';

// export default function Header({
//   currentPage,
//   navigateTo,
//   cartItemsCount,
//   openCart,
//   mobileMenuOpen,
//   setMobileMenuOpen
// }) {
//   const navItems = [
//     { label: 'Home', page: 'home' },
//     { label: 'Books', page: 'books' },
//     { label: 'Accessories', page: 'accessories' },
//     { label: 'Shop', page: 'shop' },
//     { label: 'About', page: 'about' }
//   ];

//   return (
//     <header
//       style={{
//         background: 'linear-gradient(135deg, #4527a0 0%, #5e35b1 100%)',
//         color: 'white',
//         position: 'sticky',
//         top: 0,
//         zIndex: 100,
//         boxShadow: theme.shadowMd
//       }}
//     >
//       <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
//         <div
//           style={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center',
//             height: '80px'
//           }}
//         >
//           {/* Logo & Brand */}
//           <div
//             onClick={() => navigateTo('home')}
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               cursor: 'pointer',
//               gap: 12
//             }}
//           >
//             <img
//               src={logo}
//               alt="Upendo Store"
//               style={{ height: 52, borderRadius: 8 }}
//             />
//             <span
//               style={{
//                 fontSize: '1.6rem',
//                 fontWeight: 700,
//                 letterSpacing: '0.4px',
//                 fontFamily: "'Roboto Slab', serif"
//               }}
//             >
//               UPENDO STORE
//             </span>
//           </div>

//           {/* Desktop Navigation */}
//           <nav
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               gap: '2.2rem'
//             }}
//             className="desktop-nav"
//           >
//             {navItems.map(item => (
//               <div
//                 key={item.page}
//                 onClick={() => navigateTo(item.page)}
//                 style={{
//                   fontWeight: currentPage === item.page ? 600 : 500,
//                   color: currentPage === item.page ? theme.accent : 'white',
//                   cursor: 'pointer',
//                   padding: '8px 0',
//                   borderBottom: currentPage === item.page ? `2px solid ${theme.accent}` : 'none',
//                   transition: 'all 0.2s',
//                   fontSize: '1.05rem'
//                 }}
//               >
//                 {item.label}
//               </div>
//             ))}

//             <button
//               onClick={openCart}
//               style={{
//                 background: 'none',
//                 border: 'none',
//                 color: 'white',
//                 position: 'relative',
//                 cursor: 'pointer'
//               }}
//             >
//               <ShoppingCart size={26} />
//               {cartItemsCount > 0 && (
//                 <span
//                   style={{
//                     position: 'absolute',
//                     top: -10,
//                     right: -10,
//                     background: theme.accent,
//                     color: '#111',
//                     width: 24,
//                     height: 24,
//                     borderRadius: '50%',
//                     fontSize: '0.8rem',
//                     fontWeight: 700,
//                     display: 'grid',
//                     placeItems: 'center'
//                   }}
//                 >
//                   {cartItemsCount}
//                 </span>
//               )}
//             </button>
//           </nav>

//           {/* Mobile Hamburger */}
//           <button
//             className="mobile-hamburger"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//             style={{
//               background: 'none',
//               border: 'none',
//               color: 'white',
//               fontSize: '2.1rem',
//               cursor: 'pointer',
//               display: 'none'
//             }}
//           >
//             {mobileMenuOpen ? <X size={32} /> : '☰'}
//           </button>
//         </div>

//         {/* Mobile Menu Dropdown */}
//         {mobileMenuOpen && (
//           <div
//             style={{
//               background: 'linear-gradient(135deg, #4527a0 0%, #5e35b1 100%)',
//               padding: '1.5rem 24px',
//               boxShadow: '0 12px 32px rgba(0,0,0,0.35)'
//             }}
//             className="mobile-menu"
//           >
//             {navItems.map(item => (
//               <div
//                 key={item.page}
//                 onClick={() => navigateTo(item.page)}
//                 style={{
//                   padding: '12px 0',
//                   fontSize: '1.15rem',
//                   fontWeight: currentPage === item.page ? 600 : 500,
//                   color: currentPage === item.page ? theme.accent : 'white',
//                   cursor: 'pointer'
//                 }}
//               >
//                 {item.label}
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Responsive styles */}
//       <style jsx global>{`
//         @media (max-width: 768px) {
//           .desktop-nav { display: none !important; }
//           .mobile-hamburger { display: block !important; }
//         }
//         @media (min-width: 769px) {
//           .mobile-menu { display: none !important; }
//         }
//       `}</style>
//     </header>
//   );
// }